<template>
  <div class="pricing-page">
    <Top />

    <section class="hero" aria-label="Pricing header">
      <div class="container hero-inner">

      </div>
    </section>

    <section class="pricing" aria-label="Pricing cards">
      <div class="container pricing-inner">
        <div v-if="listLoading" class="state-msg">Loading…</div>
        <div v-else-if="listError" class="state-msg state-err">{{ listError }}</div>
        <div v-else-if="!displayItems.length" class="state-msg">No pricing items yet.</div>
        <div v-else class="grid">
          <article v-for="item in displayItems" :key="'pricing-' + item.id" class="card">
            <div class="card-body">
              <div class="card-title">{{ item.title }}</div>
              <div class="card-desc">{{ item.desc }}</div>
              <div class="card-price">{{ item.price }}</div>
              <div v-if="item.time" class="card-time">{{ item.time }}</div>
            </div>
          </article>
        </div>
      </div>
    </section>

    <section class="cta-band">
      <div class="container cta-inner">
        <div class="cta-left">
          <h2 class="cta-title">AESTHETICS PRACTITIONER?</h2>
          <p class="cta-sub">
            Grow your business with DOSE and access new patients, forms, diary, reminders<br />
            and no show/late cancellation protection.
          </p>
        </div>
        <div class="cta-right">
          <button class="cta-btn" type="button" @click="goAbout">LEARN MORE</button>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Footer from '../components/footer.vue'
import Top from '../components/top.vue'
import { fetchPublicPricingList } from '../api/pricing'

export default {
  name: 'PricingPage',
  components: {
    Footer,
    Top,
  },
  data() {
    return {
      listLoading: true,
      listError: '',
      listRows: [],
    }
  },
  computed: {
    displayItems() {
      return (this.listRows || []).map((row) => ({
        id: row.id,
        title: (row.itemName && String(row.itemName).trim()) || '',
        desc: row.description != null ? String(row.description).trim() : '',
        price: this.formatPrice(row.price),
        time: this.formatServiceMinutes(row.serviceMinutes != null ? row.serviceMinutes : row.service_minutes),
      }))
    },
  },
  mounted() {
    this.loadList()
  },
  methods: {
    formatPrice(value) {
      if (value == null || value === '') return ''
      const n = Number(value)
      if (Number.isNaN(n)) return String(value)
      const decimals = Math.abs(n % 1) < 1e-9 ? 0 : 2
      return '$' + n.toFixed(decimals)
    },
    formatServiceMinutes(minutes) {
      if (minutes == null || minutes === '') return ''
      const n = Number(minutes)
      if (Number.isNaN(n) || n <= 0) return ''
      return String(Math.round(n)) + 'min'
    },
    loadList() {
      this.listLoading = true
      this.listError = ''
      fetchPublicPricingList()
        .then((list) => {
          this.listRows = list || []
        })
        .catch((e) => {
          this.listError = (e && e.message) || 'Failed to load pricing'
          this.listRows = []
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    goAbout() {
      this.$router.push({ name: 'about' }).catch((err) => {
        if (err && err.name !== 'NavigationDuplicated') throw err
      })
    },
  },
}
</script>

<style scoped>
.pricing-page {
  min-height: 100vh;
  background: #ffffff;
  color: #0c0b06;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.hero {
  background: url('../assets/images/pricingBanner.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.hero-inner {
  padding: 46px 0 34px;
  text-align: center;
}

.hero-title {
  margin: 0;
  font-size: 38px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #0c0b06;
}

.hero-rule {
  width: 28px;
  height: 2px;
  background: rgba(176, 138, 74, 0.55);
  margin: 14px auto 10px;
}

.hero-sub {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: #0c0b06;
}

.pricing-inner {
  padding: 38px 0 70px;
}

.state-msg {
  padding: 40px 0;
  text-align: center;
  color: #0c0b06;
  font-size: 13px;
}

.state-err {
  color: #a94442;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.card {
  background: #fff;
  border: 1px solid rgba(176, 138, 74, 0.35);
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.card-body {
  width: 100%;
  padding: 32px 18px 28px;
  text-align: center;
}

.card-title {
  font-size: 21px;
  letter-spacing: 0.02em;
  color: #0c0b06;
  font-weight: 500;
}

.card-desc {
  margin: 14px auto 0;
  max-width: 220px;
  font-size: 14px;
  line-height: 1.7;
  color: #0c0b06;
}

.card-price {
  margin-top: 18px;
  font-size: 26px;
  font-weight: 600;
  color: #0c0b06;
}

.card-time {
  margin-top: 6px;
  font-size: 14px;
  color: #0c0b06;
}

.cta-band {
  padding: 44px 0;
  background: #f4f3ef;
}

.cta-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
}

.cta-title {
  margin: 0;
  font-size: 18px;
  letter-spacing: 0.08em;
  font-weight: 600;
}

.cta-sub {
  margin: 10px 0 0;
  color: #0c0b06;
  font-size: 12px;
  line-height: 1.7;
}

.cta-btn {
  height: 36px;
  min-width: 150px;
  padding: 0 26px;
  border: none;
  border-radius: 0;
  background: #b08a4a;
  color: #fff;
  font-size: 11px;
  letter-spacing: 0.14em;
  cursor: pointer;
}

.cta-btn:hover {
  filter: brightness(0.96);
}

@media (max-width: 1000px) {
  .hero-title {
    font-size: 34px;
  }

  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding:0 12px;
    box-sizing: border-box;
  }
}

@media (min-width: 1001px) {
  .hero-inner {
    height: 330px;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

@media (max-width: 720px) {
  .container {
    padding: 0 12px;
  }

  .hero-inner {
    padding: 36px 0 26px;
  }

  .hero-title {
    font-size: 30px;
  }

  .pricing-inner {
    padding: 28px 0 54px;
  }

  .grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding:0 12px;
    box-sizing: border-box;
  }

  .card-body {
    padding: 28px 16px 24px;
  }

  .cta-inner {
    flex-direction: column;
    align-items: flex-start;
  }

  .cta-btn {
    width: 100%;
    max-width: 220px;
  }
}
</style>
